/*
  rk-main-product: Galerie (Swipe, Punkte, Thumbnails, Zoom), Variante aus dem
  Formular (rk-bundle.js setzt input[name="id"]), Lieferbox, Bewertungslink, Akkordeons, Sticky-Leiste.
  Warenkorb läuft über product-form.js.
*/
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile = () => window.matchMedia('(max-width: 989px)').matches;

  function initGallery(root) {
    const slides = Array.from(root.querySelectorAll('[data-rk-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-rk-thumb]'));
    const strip = root.querySelector('[data-rk-thumbs]');
    const track = root.querySelector('[data-rk-slides]');
    if (!track || !slides.length) return () => {};

    function mark(index) {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
        if (i === index) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      const thumb = thumbs[index];
      if (strip && thumb) {
        const left = thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
        strip.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      slides.forEach((s, i) => {
        if (i !== index) s.querySelectorAll('video').forEach((v) => v.pause());
      });
    }

    function show(index) {
      mark(index);
      if (mobile()) {
        track.scrollTo({ left: slides[index].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    thumbs.forEach((t) => t.addEventListener('click', () => show(Number(t.dataset.rkThumb))));
    root.querySelectorAll('[data-rk-thumbnav]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!strip) return;
        strip.scrollBy({ left: Number(btn.dataset.rkThumbnav) * strip.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });

    let raf = 0;
    track.addEventListener('scroll', () => {
      if (!mobile()) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        mark(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)));
      });
    }, { passive: true });

    const dialog = root.querySelector('[data-rk-zoom-dialog]');
    root.querySelectorAll('[data-rk-zoom]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!dialog || typeof dialog.showModal !== 'function') return;
        const img = dialog.querySelector('img');
        img.src = btn.dataset.full;
        img.alt = btn.querySelector('img')?.alt || '';
        dialog.showModal();
      });
    });
    root.querySelectorAll('[data-rk-close]').forEach((b) => b.addEventListener('click', () => b.closest('dialog')?.close()));
    dialog?.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });

    return (mediaId) => {
      const index = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (index >= 0) show(index);
    };
  }

  function initDelivery(root) {
    const el = root.querySelector('[data-rk-delivery]');
    const out = el && el.querySelector('[data-rk-delivery-date]');
    if (!out) return;
    const date = new Date();
    date.setDate(date.getDate() + Number(el.dataset.days || 2));
    out.textContent = date.toLocaleDateString('de-DE', { weekday: 'short', day: 'numeric', month: 'long' });
  }

  function initReviewLink(root) {
    root.querySelectorAll('[data-rk-scroll]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const id = (link.getAttribute('href') || '').slice(1);
        const target = document.getElementById(id) || document.querySelector('.rk-reviews, #looxReviews');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initAccordion(root) {
    const group = root.querySelector('[data-rk-accordion]');
    if (!group) return;
    const items = Array.from(group.querySelectorAll('details.rk-acc'));

    items.forEach((details) => {
      const content = details.querySelector('.rk-acc__content');
      if (content) buildTable(content);
      const summary = details.querySelector('summary');

      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (details.open) close(details);
        else {
          items.forEach((d) => { if (d !== details && d.open) close(d); });
          open(details);
        }
      });

      function animate(d, from, to, done) {
        const b = d.querySelector('.rk-acc__body');
        clearTimeout(d._rkTimer);
        b.style.height = from + 'px';
        void b.offsetHeight;
        b.style.height = to + 'px';
        d._rkTimer = setTimeout(() => { b.style.height = ''; done(); }, 320);
      }

      function open(d) {
        d.open = true;
        if (reduceMotion) return;
        animate(d, 0, d.querySelector('.rk-acc__body').scrollHeight, () => {});
      }

      function close(d) {
        if (reduceMotion) { d.open = false; return; }
        animate(d, d.querySelector('.rk-acc__body').scrollHeight, 0, () => { d.open = false; });
      }
    });
  }

  /* Absätze „<strong>Label</strong> – Wert“ werden zu einer Mini-Tabelle zusammengefasst. */
  function buildTable(content) {
    const rows = Array.from(content.children).filter((el) => {
      if (el.tagName !== 'P') return false;
      const strong = el.firstElementChild;
      const text = el.textContent.trim();
      return strong && strong.tagName === 'STRONG' && text.startsWith(strong.textContent.trim()) && text.includes(' – ');
    });
    let table = null;
    rows.forEach((p) => {
      const prev = p.previousElementSibling;
      if (!table || prev !== table) {
        table = document.createElement('dl');
        table.className = 'rk-acc__table';
        p.before(table);
      }
      const text = p.textContent.trim();
      const cut = text.indexOf(' – ');
      const row = document.createElement('div');
      const dt = document.createElement('dt');
      const dd = document.createElement('dd');
      dt.textContent = text.slice(0, cut);
      dd.textContent = text.slice(cut + 3);
      row.append(dt, dd);
      table.append(row);
      p.remove();
    });
  }

  function init(root) {
    const showMedia = initGallery(root);
    initDelivery(root);
    initReviewLink(root);
    initAccordion(root);

    const data = JSON.parse(root.querySelector('[data-rk-variants]')?.textContent || '{"variants":[]}');
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const input = form?.querySelector('input[name="id"]');
    const atc = root.querySelector('[data-rk-atc]');
    const atcLabel = root.querySelector('[data-rk-atc-label]');
    const priceEl = root.querySelector('[data-rk-price]');
    const compareEl = root.querySelector('[data-rk-compare]');
    const badgeEl = root.querySelector('[data-rk-badge]');
    const bar = root.querySelector('[data-rk-sticky-atc]');
    const barVariant = root.querySelector('[data-rk-bar-variant]');
    const barPrice = root.querySelector('[data-rk-bar-price]');
    const barButton = root.querySelector('[data-rk-bar-atc]');
    const barLabel = root.querySelector('[data-rk-bar-label]');
    const notify = root.querySelector('rk-notify');
    let currentId = '';

    /* Alles ausverkauft: Bundle-Auswahl ruhigstellen, nur „Bald wieder da“ ist aktiv */
    if (notify && data.variants.length && data.variants.every((x) => !x.available)) {
      root.querySelectorAll('.rk-bundle__list').forEach((list) => { list.inert = true; });
    }

    function apply(id) {
      const v = data.variants.find((x) => String(x.id) === String(id));
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        compareEl.hidden = !v.compare;
        if (v.compare) compareEl.textContent = v.compare;
      }
      if (badgeEl) {
        const off = v.compare ? Math.round((1 - v.priceCents / v.compareCents) * 100) : 0;
        badgeEl.hidden = off <= 0;
        if (off > 0) badgeEl.textContent = '-' + off + ' %';
      }
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? atc.dataset.label : atc.dataset.soldout;
      }
      if (notify) {
        notify.hidden = v.available;
        root.classList.toggle('is-soldout', !v.available);
        if (!v.available) {
          if (typeof notify.setVariant === 'function') notify.setVariant(v.id);
          else notify.dataset.variant = v.id;
        }
      }
      if (barButton) {
        barButton.disabled = !v.available && !notify;
        if (barLabel) {
          barLabel.textContent = !v.available && notify ? barButton.dataset.notifyLabel : barButton.dataset.label;
        }
      }
      if (barVariant) barVariant.textContent = data.variants.length > 1 ? v.title : '';
      if (barPrice) barPrice.textContent = v.price;
      document.querySelectorAll('[data-rk-variant-mirror]').forEach((el) => { el.value = v.id; });
      if (v.mediaId) showMedia(v.mediaId);
    }

    function check() {
      if (!input || input.value === currentId) return;
      currentId = input.value;
      apply(currentId);
    }

    if (input) {
      form.addEventListener('change', check);
      new MutationObserver(check).observe(input, { attributes: true, attributeFilter: ['value'] });
      window.setInterval(check, 500);
      check();
    }
    document.addEventListener('change', (e) => {
      if (e.target && e.target.name === 'id' && e.target.form === form) check();
    });

    if (bar && atc && 'IntersectionObserver' in window) {
      let atcOut = false;
      let footerIn = false;
      const sync = () => {
        const show = atcOut && !footerIn;
        bar.hidden = !show;
        document.documentElement.classList.toggle('rk-buybar-on', show);
      };
      let raf = 0;
      const measure = () => {
        raf = 0;
        const anchor = notify && !notify.hidden ? notify : atc;
        atcOut = anchor.getBoundingClientRect().bottom < 0;
        sync();
      };
      window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(measure); }, { passive: true });
      measure();
      const footer = document.querySelector('.rk-footer, footer, .footer');
      if (footer) new IntersectionObserver(([entry]) => { footerIn = entry.isIntersecting; sync(); }).observe(footer);
    }
    barButton?.addEventListener('click', () => {
      if (notify && !notify.hidden && typeof notify.open === 'function') notify.open({ scroll: true });
      else atc?.click();
    });

    document.querySelectorAll('[data-rk-pick]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        let picked = false;
        const pick = () => {
          if (picked) return;
          picked = true;
          pickOption(link.dataset.rkPick);
        };
        window.addEventListener('scrollend', pick, { once: true });
        setTimeout(pick, 1000);
        root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* Farbe in der Bundle-Auswahl (rk-bundle.js) wählen */
  function pickOption(value) {
    if (!value) return;
    document.dispatchEvent(new CustomEvent('rk:bundle-pick', { detail: value }));
  }

  document.querySelectorAll('.rk-pdp').forEach(init);
})();
